import styled from 'styled-components';

export const TableWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: 20px;
`;

export const ButtonsWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 10px;
`;
